import { lazyNamed } from 'src/utils/lazyNamed';
import { PDFStylesFormSearchParams } from './pages/PDFStylesForm/types';

export const CompanySettings = {
  // common
  Layout: lazyNamed(() => import('./components/Layout'), 'Layout'),
  SalesUnitsProvider: lazyNamed(() => import('./components/SalesUnitsProvider'), 'SalesUnitsProvider'),

  // containers
  PPTReportConfig: lazyNamed(() => import('./containers/PPTReportConfig'), 'PPTReportConfig'),

  // pages
  CoopWeeks: lazyNamed(() => import('./pages/CoopWeeks'), 'CoopWeeks'),
  EmailTemplateForm: lazyNamed(() => import('./pages/EmailTemplateForm'), 'EmailTemplateForm'),
  EmailTemplates: lazyNamed(() => import('./pages/EmailTemplates'), 'EmailTemplates'),
  PaymentDetails: lazyNamed(() => import('./pages/PaymentDetails'), 'PaymentDetails'),
  PaymentDetailsForm: lazyNamed(() => import('./pages/PaymentDetailsForm'), 'PaymentDetailsForm'),
  PDFFooterTemplates: lazyNamed(() => import('./pages/PDFFooterTemplates'), 'PDFFooterTemplates'),
  PDFStylesForm: lazyNamed(() => import('./pages/PDFStylesForm'), 'PDFStylesForm'),
  PDFStyles: lazyNamed(() => import('./pages/PDFStyles'), 'PDFStyles'),
  PDFTypeConfigurations: lazyNamed(() => import('./pages/PDFTypeConfigurations'), 'PDFTypeConfigurations'),
  Sequencing: lazyNamed(() => import('./pages/Sequencing'), 'Sequencing'),

  // search params
  PDFStylesFormSearchParams,
};
